import app from 'vue'

app.directive('focus', {
  inserted: (element, { value }) => {
    if (!value) return
    element = element.querySelector('.input.takes-focus') || element
    setTimeout(() => element.focus(), 50)
  }
})
